<template>
  <section>
    <!-- SB-01 -->
    <banner-full-width headerText="Pour la suite"></banner-full-width>
    <div
      id="sb-52"
      v-if="$store.state.currentLocation >= 52"
    >
      <content-block>
        <!-- 5-01-00 -->
        <!-- <banner-full-width headerText=""></banner-full-width> -->
        <!-- <h1 class="animated infinite bounce delay-2s">Example</h1> -->
        <h2 class="content-block__header content-block__header--red">Les fondements de la sécurité en aviron </h2>
        <p>Voici un bref récapitulatif de ce que vous devez savoir et faire pour veiller à votre sécurité sur l'eau.</p>
        <div class="accordion-group">
          <accordion
            header-text="Évaluation des risques"
            class="accordion--red "
          >
            <p>
              Même si vous êtes bien préparé, si vous voyez quelque chose sur l'eau qui ne semble pas sécuritaire, avisez quelqu'un.
            </p>
            <ul>
              <li>Pour évaluer vos risques{{'\xa0'}}:
                <ul>
                  <li>Déterminez les risques liés à votre sortie prévue.  </li>
                  <li>Analysez ces risques.  </li>
                  <li>Ayez un plan d'action pour chaque risque. </li>
                </ul>
              </li>
            </ul>
          </accordion>
          <accordion
            header-text="Sécurité nautique"
            class="accordion--red"
          >
            <p>Tous les rameurs et les entraîneurs sont responsables de connaître les règlements nautiques de Transports Canada et de les respecter. De plus{{'\xa0'}}:</p>
            <ul>
              <li>Les conducteurs doivent prendre toutes les mesures requises pour éviter les accidents et les collisions.  </li>
              <li>La personne qui dirige l'embarcation est la personne responsable. Avant de sortir sur l'eau, il est recommandé de toujours déterminer la personne responsable.  </li>
              <li>Le fait de ramer dans l’obscurité, de ramer avant le lever du soleil et de ramer après le coucher du soleil présentent de plus grands risques et RCA ne le recommande pas.</li>
            </ul>
          </accordion>
          <accordion
            header-text="Environnement et conditions météo"
            class="accordion--red"
          >
            <ul>
              <li>S'il y a de forts vents, de grandes vagues, du tonnerre, des éclairs ou du brouillard avant votre sortie, ne sortez pas sur l'eau.  </li>
              <li>Si des conditions météorologiques extrêmes surviennent alors que vous êtes sur l'eau, retournez au hangar à bateau ou rendez-vous au lieu sûr le plus près.</li>
            </ul>
          </accordion>
          <accordion
            header-text="Intervention en cas d'urgence (pour l'athlète)"
            class="accordion--red"
          >
            <ul>
              <li>Apprenez à vous aider vous-même et à aider les autres en cas d'urgence lorsque vous êtes seul ou en équipage sur l'eau.</li>
              <li>N'oubliez pas que vous êtes responsable de la sécurité des personnes qui devront peut-être vous porter secours.</li>
              <li>Habillez-vous convenablement selon les conditions pour vous protéger contre l'hypothermie ou l'hyperthermie.</li>
              <li>Apprenez à reconnaître les signes et les symptômes de commotions cérébrales. Si vous soupçonnez une commotion cérébrale, cessez l'activité physique et obtenez des soins médicaux immédiatement.</li>
            </ul>
          </accordion>
          <accordion
            header-text="Sécurité individuelle"
            class="accordion--red"
          >
            <p>Avant de sortir sur l'eau, pensez à{{'\xa0'}}:</p>
            <ul>
              <li>Votre aptitude à nager</li>
              <li>Votre confort avec le VFI</li>
              <li>Vos connaissances de la circulation sur le plan d'eau</li>
              <li>Votre entraînement prévu</li>
            </ul>
          </accordion>
          <accordion
            header-text="Équipement"
            class="accordion--red"
          >
            <p>Avant de mettre votre embarcation à l'eau, vérifiez que tous les composants sont fonctionnels. Ajustez les composants au besoin. Si un composant n'est pas sécuritaire, ne sortez pas sur l'eau.</p>
            <p>Vérifiez{{'\xa0'}}:</p>
            <ul>
              <li>Les parties de la coque d'aviron</li>
              <li>L'équipement de sécurité en place dans l'embarcation</li>
              <li>Les cale-pieds</li>
              <li>Le siège</li>
              <li>La dérive et la balle de proue</li>
              <li>Les rames </li>
            </ul>
          </accordion>
        </div>
        <button-sequenced
          class="btn-nav--red"
          :loc="53"
          link="sb-53"
        >
          J'y veillerai
        </button-sequenced>
      </content-block>
    </div>

    <!-- SB-53 -->
    <div
      id="sb-53"
      class="bg-img bg-img--04"
      v-if="$store.state.currentLocation >= 53"
    >
      <content-block>
        <h2 class="content-block__header content-block__header--red">Merci</h2>
        <p>Merci du temps que vous avez consacré à la sécurité en aviron et de votre intérêt.  </p>
        <p>En augmentant votre conscience de la situation sur l'eau, vous, ainsi que ceux qui vous entourent, pouvez mieux profiter de notre sport de manière sécuritaire et responsable. </p>
        <button-sequenced
          class="btn-nav--red"
          :loc="54"
          link="menu"
        >
          Je ramerai prudemment
        </button-sequenced>
      </content-block>
    </div>

    <!-- <footer
      class="course-menu"
      id="menu"
      v-if="$store.state.currentLocation >= 54"
    >
      <h3>Course Menu</h3>
      <cac-menu :menuItems="$store.state.menuItems"></cac-menu>
    </footer> -->
  </section>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import CacHeader from '@/components/cac-components/CacHeader.vue';
import CacMenu from '@/components/cac-components/CacMenu.vue';
import BannerFullWidth from '@/components/BannerFullWidth.vue';
import ContentBlock from '@/components/ContentBlock.vue';
import ButtonSequenced from '@/components/ButtonSequenced.vue';
import AccordionIcon from '@/components/AccordionIcon.vue';
import Accordion from '@/components/Accordion.vue';

// Quiz stuff
import QuizRadio from '@/components/QuizRadio.vue';
import QuizCheckbox from '@/components/QuizCheckbox.vue';

export default {
  name: 'nccp',
  components: {
    CacHeader,
    CacMenu,
    BannerFullWidth,
    ContentBlock,
    ButtonSequenced,
    AccordionIcon,
    Accordion,
    QuizRadio
  },
  data() {
    return {
      showModal: false,
      // 3-01-03
      q01: [
        // Q1
        {
          id: 0,
          questionText: `
            <p>You’re scheduled to go out on the water with a group of beginner rowers. It’s pretty grey out, but the water is calm. The weather forecast says there’s a 20% chance of thunderstorms in about 2 hours. They’re calling for strong winds if the storm hits.</p>
            <p>Is it safe to take the group out?</p>
          `,
          questionArray: [
            'Yes. It’s safe as long as you’re back in an hour, before the storm arrives.',
            'Yes. It’s safe, since the chance of a storm is low.',
            'No. It’s too risky.',
          ],
          corrective: 'No. It’s too risky.',
          model: [],
          answer: '',
          answerText: `
            <p>Even though the storm isn’t scheduled to hit for 2 hours, weather can change quickly. A storm will create rough conditions that make it hard to get back to the dock, especially for beginner rowers.</p>
          `,
        },
      ],
    };
  },
  methods: {
    tabContent(index) {
      this.tabIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
/*------------------------------------*\
    #PRIMARY COLOURS
  \*------------------------------------*/

/*------------------------------------*\
    #Mixins
  \*------------------------------------*/

/*------------------------------------
    #MEDIA SCREENS < 768px (#MOBILE FIRST)
  \*------------------------------------*/
.banner {
  // background-image: url('../assets/img/_chapter-headers/mbl/01-welcome-mbl.png');
  background-image: url("../assets/img/_chapter-headers/mbl/8-whats-next-mbl-fr.jpg");
  color: #000;
  background-position: center;
  padding: 60% 10%;
  &__header {
    color: #000;
  }
}

/*------------------------------------*\
    #MEDIA SCREENS > 576px (TABLETS)
  \*------------------------------------*/
@media (min-width: 576px) {
  .banner {
    background-image: url("../assets/img/_chapter-headers/dsk/8-whats-next-dsk-fr.jpg");
    // background-image: url('../assets/img/_chapter-headers/dsk/01-welcome-dsk.png');
    color: #000;
    padding: 10% 10% 14%;
    background-position: center;
    &__header {
      color: #000;
    }
  }
}

/*------------------------------------*\
  #MEDIA SCREENS > 767px (TABLETS)
\*------------------------------------*/
@media (min-width: 767px) {
  // .banner {
  //   background-image: url('../assets/img/_bg/1-01-01-bg-dsk.png');
  //   color: #fff;
  //   padding: 10% 10%;
  //   background-position: center;
  //   &__header {
  //       color: #fff;
  //   }
  // }
}

/*------------------------------------*\
    #MEDIA SCREENS > 992px
    (LAPTOP, TABLET)
  \*------------------------------------*/
@media (min-width: 992px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1200px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1200px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1320px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1320px) {
}

/*------------------------------------*\
    #MEDIA SCREENS > 1600px (DESKTOP)
  \*------------------------------------*/
@media (min-width: 1600px) {
}
</style>
